import type { Point } from '../../../context/context';

export function getNextQuickStartHubName(points: Point[]) {
  const nextHubNumber =
    points
      .filter((point) => point.creationSource === 'quick-start-hub')
      .reduce((maxHubNumber, point) => {
        const match = /^Hub (\d+)$/i.exec(point.name.trim());
        const hubNumber = match ? Number(match[1]) : 0;
        return Number.isFinite(hubNumber) ? Math.max(maxHubNumber, hubNumber) : maxHubNumber;
      }, 0) + 1;

  return `Hub ${nextHubNumber}`;
}
